import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Gift } from 'lucide-react';
export function BonusSection() {
  return <section className="py-10 md:py-14 px-4 bg-slate-950" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <FadeIn className="text-center mb-8" data-id="element-23">
          <Gift className="w-9 h-9 text-amber-500 mx-auto mb-3" strokeWidth={2} data-id="element-24" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white tracking-wide mb-2" data-id="element-25">
            4 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-amber-500 font-bold tracking-widest uppercase text-sm" data-id="element-26">
            SIEMPRE INCLUIDOS
          </p>
        </FadeIn>

        <div className="space-y-6" data-id="element-27">
          {/* Bono 1 */}
          <FadeIn delay={0.1} data-id="element-28">
            <div className="bg-slate-900 border border-slate-800 border-t-4 border-t-green-500 rounded-b-xl p-6 md:p-8 shadow-md" data-id="element-29">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4" data-id="element-30">
                <p className="text-white font-bold text-lg flex items-center gap-2" data-id="element-31">
                  <span data-id="element-32">🟢</span> BONO 1
                </p>
                <div className="bg-slate-950 px-4 py-1.5 rounded-full border border-slate-800 inline-flex items-center gap-2 w-fit" data-id="element-33">
                  <span className="text-slate-500 line-through text-sm" data-id="element-34">
                    Valor: $8.990
                  </span>
                  <span className="text-green-500 font-bold text-sm" data-id="element-35">
                    → GRATIS
                  </span>
                </div>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-green-500 mb-4" data-id="element-36">
                Diagnóstico Express de Dolor y Ajuste Fino
              </h3>
              <p className="text-slate-400 text-base md:text-lg leading-relaxed" data-id="element-37">
                Tabla Síntoma → Causa → Ajuste. 5 tests caseros y protocolo de
                ajuste fino en 15 min. Sin biomecánico.
              </p>
            </div>
          </FadeIn>

          {/* Bono 2 */}
          <FadeIn delay={0.2} data-id="element-38">
            <div className="bg-slate-900 border border-slate-800 border-t-4 border-t-blue-500 rounded-b-xl p-6 md:p-8 shadow-md" data-id="element-39">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4" data-id="element-40">
                <p className="text-white font-bold text-lg flex items-center gap-2" data-id="element-41">
                  <span data-id="element-42">🔵</span> BONO 2
                </p>
                <div className="bg-slate-950 px-4 py-1.5 rounded-full border border-slate-800 inline-flex items-center gap-2 w-fit" data-id="element-43">
                  <span className="text-slate-500 line-through text-sm" data-id="element-44">
                    Valor: $8.990
                  </span>
                  <span className="text-green-500 font-bold text-sm" data-id="element-45">
                    → GRATIS
                  </span>
                </div>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-blue-500 mb-4" data-id="element-46">
                Guía de Estrategia de Subidas
              </h3>
              <p className="text-slate-400 text-base md:text-lg leading-relaxed" data-id="element-47">
                Fórmula 30/40/30, cadencia por tipo de subida y 3 fichas
                imprimibles (corta, media, larga).
              </p>
            </div>
          </FadeIn>

          {/* Bono 3 */}
          <FadeIn delay={0.3} data-id="element-48">
            <div className="bg-slate-900 border border-slate-800 border-t-4 border-t-orange-500 rounded-b-xl p-6 md:p-8 shadow-md" data-id="element-49">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4" data-id="element-50">
                <p className="text-white font-bold text-lg flex items-center gap-2" data-id="element-51">
                  <span data-id="element-52">🟠</span> BONO 3
                </p>
                <div className="bg-slate-950 px-4 py-1.5 rounded-full border border-slate-800 inline-flex items-center gap-2 w-fit" data-id="element-53">
                  <span className="text-slate-500 line-through text-sm" data-id="element-54">
                    Valor: $8.990
                  </span>
                  <span className="text-green-500 font-bold text-sm" data-id="element-55">
                    → GRATIS
                  </span>
                </div>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-orange-500 mb-4" data-id="element-56">
                Bitácora de Progreso 12 Semanas
              </h3>
              <p className="text-slate-400 text-base md:text-lg leading-relaxed" data-id="element-57">
                Scorecard de salida, registro semanal y retest final. Ver tu
                progreso en papel.
              </p>
            </div>
          </FadeIn>

          {/* Bono 4 */}
          <FadeIn delay={0.4} data-id="element-58">
            <div className="bg-slate-900 border border-slate-800 border-t-4 border-t-purple-500 rounded-b-xl p-6 md:p-8 shadow-md" data-id="element-59">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4" data-id="element-60">
                <p className="text-white font-bold text-lg flex items-center gap-2" data-id="element-61">
                  <span data-id="element-62">🟣</span> BONO 4
                </p>
                <div className="bg-slate-950 px-4 py-1.5 rounded-full border border-slate-800 inline-flex items-center gap-2 w-fit" data-id="element-63">
                  <span className="text-slate-500 line-through text-sm" data-id="element-64">
                    Valor: $8.990
                  </span>
                  <span className="text-green-500 font-bold text-sm" data-id="element-65">
                    → GRATIS
                  </span>
                </div>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-purple-500 mb-4" data-id="element-66">
                Checklist Pre-Salida de Rendimiento Total
              </h3>
              <p className="text-slate-400 text-base md:text-lg leading-relaxed" data-id="element-67">
                Cuerpo, bici, combustible y objetivo en 3 minutos. Evitá los
                errores antes del primer km.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.5} data-id="element-68">
          <div className="mt-8 text-center bg-amber-500/10 border border-amber-500/30 rounded-2xl p-6" data-id="element-69">
            <p className="text-lg md:text-xl text-white" data-id="element-70">
              Valor total de los bonos:{' '}
              <span className="text-slate-400 line-through mx-2" data-id="element-71">$35.960</span>{' '}
              <span className="text-amber-500 font-bold" data-id="element-72">
                → GRATIS con tu PROTORRENDA 4-12
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}